const Gdot = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <g>
      <g>
        <path
          style={{
            fill: "#161719",
          }}
          d="M0 0h512v512H0z"
        />
        <path
          fill="#eee"
          d="M90.39 308.09c-18.78.59-35.46-12.1-34.94-31.5 1.23-12.16-3.46-51 4.37-61 16-25.71 67.2-17.15 65.51 16.61h-21.48c1.24-12.75-15.59-16.41-23.41-9.6q-3.51 3.3-3.51 9.6c1.33 7.27-3.39 49.14 3.51 53.91 4.21 4.49 15.69 4.49 19.9 0 4.57-3.56 3.39-13.12 3.51-18.54H88.39v-18.19h36.94c1.1 28.25 2.49 58.46-34.94 58.71ZM149.38 269.43v-20.05h45.82v20.05ZM245.89 308.09c-16.65 0-25.73-14.19-25.49-30.79.2-12.5-2-33.52 7.09-42.45 10.52-13.34 34.6-10.44 39.59 6.65h.43c-.6-9.66-.86-29.62-.72-39.37h21.48v104.53h-20.76v-13.61h-.43c-3.41 9.53-10.97 15.1-21.19 15.04Zm8.31-18.62c8.5 0 12.62-5.17 12.59-13.6-.57-10.41 3.93-31.77-12.6-30.79-8 0-12.36 4.78-12.31 12.89.74 10.2-4.32 32.51 12.32 31.5ZM337.24 308.09c-18.82.63-34.92-12.21-34.36-31.5-2.06-26.38 2.5-50 34.36-50.12 18.93-.66 34.87 12.2 34.37 31.5 2.2 26.03-2.8 50.3-34.37 50.12Zm0-18.62c17.18 1.26 12.23-21 12.89-31.5 0-8.38-4.51-12.91-12.89-12.89s-12.93 4.58-12.88 12.89c.64 10.52-4.22 32.7 12.88 31.5ZM428.31 306.66c-32.95 1.47-25-38.3-25.77-59.43h-20.77V227.9h20.77v-22.19H424v22.19h29.36v19.33H424c2.5 38.71-11.45 41.64 27.93 40.1v19.33Z"
        />
      </g>
    </g>
  </svg>
);

export default Gdot;
